export const constructReturnURL = (href: string) => {
  const returnURL = new URL(href);
  // eslint-disable-next-line unicorn/prefer-global-this -- disable to get version bump through
  if (typeof window !== "undefined") {
    returnURL.searchParams.set("useIdx", "true");
    // eslint-disable-next-line unicorn/prefer-global-this -- disable to get version bump through
    returnURL.searchParams.set("returnUrl", window.location.href);
  }

  return returnURL.href;
};
